import { Component, ViewEncapsulation, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  DownloadNodesAction,
  EditOfflineAction,
} from '@alfresco/aca-shared/store';
import { ToggleEditOfflineComponent } from '@adw/projects/aca-content/src/lib/components/toolbar/toggle-edit-offline/toggle-edit-offline.component';
import { AppStore } from '../../store/states/app.state';
import {
  ReloadDocumentListAction,
  SnackbarErrorAction,
} from '../../store/actions/app.custom-actions';
import { AlfrescoApiService } from '@alfresco/adf-content-services';
import {
  AppExtensionService,
  isLocked,
} from '@adw/projects/aca-shared/src/public-api';
import { SharedLinkEntry } from '@alfresco/js-api';

@Component({
  selector: 'wk-toggle-edit-offline',
  templateUrl: './wk-toggle-edit-offline.component.html',
  styleUrls: ['wk-toggle-edit-offline.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'wk-toggle-edit-offline' },
  standalone: false,
})
export class WkToggleEditOfflineComponent extends ToggleEditOfflineComponent {
  private readonly wkStore: Store<AppStore>;
  private readonly router: Router;

  constructor(injector: Injector) {
    super(
      injector.get<Store<AppStore>>(Store<AppStore>),
      injector.get<AlfrescoApiService>(AlfrescoApiService),
      injector.get<AppExtensionService>(AppExtensionService)
    );
    this.wkStore = injector.get<Store<AppStore>>(Store<AppStore>);
    this.router = injector.get<Router>(Router);
  }

  public onToggleEvent(isNodeLocked: boolean): void {
    if (isNodeLocked) {
      this.wkStore.dispatch(new DownloadNodesAction([this.selection]));
    }
    this.wkStore.dispatch(new EditOfflineAction(this.selection));
    this.wkStore.dispatch(new ReloadDocumentListAction());
  }

  public async onClick(): Promise<void> {
    const id =
      (this.selection as SharedLinkEntry).entry.nodeId ||
      this.selection.entry.id;

    if (isLocked(this.selection)) {
      try {
        const response = await this.unlockNode(id);
        this.updateNodeProperties(response?.entry);
        this.wkStore.dispatch(new EditOfflineAction(this.selection));
        if (this.router.url.includes('/all-docs-dashboard')) {
          this.wkStore.dispatch(new ReloadDocumentListAction());
        }
      } catch {
        this.onUnlockError();
      }
    } else {
      try {
        const response = await this.lockNode(id);
        this.updateNodeProperties(response?.entry);
        this.wkStore.dispatch(new DownloadNodesAction([this.selection]));
        this.wkStore.dispatch(new EditOfflineAction(this.selection));
        if (this.router.url.includes('/all-docs-dashboard')) {
          this.wkStore.dispatch(new ReloadDocumentListAction());
        }
      } catch {
        this.onLockError();
      }
    }
  }

  private updateNodeProperties(data: any) {
    if (data && data.properties) {
      const properties = this.selection.entry.properties || {};
      properties['cm:lockLifetime'] = data.properties['cm:lockLifetime'];
      properties['cm:lockOwner'] = data.properties['cm:lockOwner'];
      properties['cm:lockType'] = data.properties['cm:lockType'];
      this.selection.entry.properties = properties;
    }
  }

  public onLockError(): void {
    this.wkStore.dispatch(
      new SnackbarErrorAction('APP.MESSAGES.ERRORS.LOCK_NODE', {
        fileName: this.selection.entry.name,
      })
    );
  }

  public onUnlockLockError(): void {
    this.wkStore.dispatch(
      new SnackbarErrorAction('APP.MESSAGES.ERRORS.UNLOCK_NODE', {
        fileName: this.selection.entry.name,
      })
    );
  }
}
